import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35aed3bd")

_pushScopeId("data-v-35aed3bd")
const _hoisted_1 = { class: "dt-open-api-detail-head" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("API说明")
const _hoisted_3 = {
  key: 0,
  class: "select-box"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 版本： ")
const _hoisted_5 = { class: "dt-open-api-detail-base-info" }
const _hoisted_6 = { class: "dt-open-api-detail-content" }
const _hoisted_7 = { class: "dt-open-api-api-table" }
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"14px","line-height":"24px"}
}
const _hoisted_9 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_10 = {
  key: 1,
  style: {"margin-left":"10px"}
}
const _hoisted_11 = { class: "dt-open-api-api-table" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h1", null, "请求参数：", -1)
const _hoisted_13 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_14 = {
  key: 1,
  style: {"margin-left":"10px"}
}
const _hoisted_15 = { class: "dt-open-api-api-table" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h1", null, "返回参数：", -1)
const _hoisted_17 = { class: "dt-open-api-api-table" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h1", null, "请求示例：", -1)
const _hoisted_19 = { class: "dt-open-api-api-demo" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("\r\n      ")
const _hoisted_22 = { class: "dt-open-api-api-table" }
const _hoisted_23 = /*#__PURE__*/_createVNode("h1", null, "返回示例：", -1)
const _hoisted_24 = { class: "dt-open-api-api-demo" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("\r\n      ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
        default: _withId(() => [
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, {
            to: { name: 'interfacelist',params:{groupid:_ctx.groupid,groupname:_ctx.groupname} }
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.groupname), 1 /* TEXT */)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.apiBaseInfo.title), 1 /* TEXT */)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isShowVersion)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_select, {
              modelValue: _ctx.curVersionId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.curVersionId = $event)),
              onChange: _ctx.calParamsData,
              "no-data-text": "暂无版本"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.version,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("strong", null, _toDisplayString(_ctx.apiBaseInfo.title), 1),
      _createVNode("p", null, _toDisplayString(_ctx.apiBaseInfo.introduce), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("h1", null, _toDisplayString(_ctx.isShowVersion ? '接口说明：':'公共参数：'), 1),
        (_ctx.isShowVersion)
          ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.versionDesc), 1))
          : (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _ctx.apiPublicParamsTemp,
              style: {"width":"100%","margin-bottom":"20px"},
              "empty-text": "暂无数据",
              border: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  prop: "paramName",
                  label: "参数名",
                  width: "180"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "type",
                  label: "类型",
                  width: "180"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "isRequire",
                  label: "是否必填"
                }, {
                  default: _withId((scope) => [
                    (scope.row.isRequire)
                      ? (_openBlock(), _createBlock("span", _hoisted_9, "是"))
                      : (_openBlock(), _createBlock("span", _hoisted_10, "否"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "description",
                  label: "说明"
                })
              ]),
              _: 1
            }, 8, ["data"]))
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_el_table, {
          data: _ctx.apiParamsTemp,
          style: {"width":"100%","margin-bottom":"20px"},
          "empty-text": "暂无数据",
          border: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              prop: "paramName",
              label: "参数名",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "类型",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "isRequire",
              label: "是否必填"
            }, {
              default: _withId((scope) => [
                (scope.row.isRequire)
                  ? (_openBlock(), _createBlock("span", _hoisted_13, "是"))
                  : (_openBlock(), _createBlock("span", _hoisted_14, "否"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "说明"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_el_table, {
          data: _ctx.apiReturnParamsTemp,
          style: {"width":"100%","margin-bottom":"20px"},
          "empty-text": "暂无数据",
          "row-key": "id",
          border: "",
          "default-expand-all": "",
          "tree-props": {children: 'children', hasChildren: 'hasChildren'}
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              prop: "fieldName",
              label: "参数名",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "类型",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "说明"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("pre", _hoisted_19, [
          _hoisted_20,
          _createVNode("code", null, _toDisplayString(_ctx.requstHtml), 1),
          _hoisted_21
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode("pre", _hoisted_24, [
          _hoisted_25,
          (_ctx.apiBaseInfo.returnExample)
            ? (_openBlock(), _createBlock("code", _hoisted_26, _toDisplayString(JSON.parse(_ctx.apiBaseInfo.returnExample)), 1))
            : (_openBlock(), _createBlock("code", _hoisted_27, "暂无示例")),
          _hoisted_28
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
})